import { createSelector } from "@reduxjs/toolkit";
import { MenuLookups } from "../../../utils/cart/menuLookup";
import type { RootState } from "../app/store";
import { SubItemType } from "../../../utils/types";

export const selectSubItemLookup = (state: RootState) =>
  state.config.subItemLookupByUuid ?? {};

export const selectAddonSubItemLookup = (state: RootState) =>
  state.config.addonSubItemLookupByUuid ?? {};

export const selectAddonGroupLookup = (state: RootState) =>
  state.config.addonGroupLookupByUuid ?? {};

export const selectMenuLookups: (state: RootState) => MenuLookups =
  createSelector(
    [selectSubItemLookup, selectAddonSubItemLookup, selectAddonGroupLookup],
    (subItemsByUuid, addonSubItemsByUuid, addonGroupsByUuid) => ({
      subItemsByUuid,
      addonSubItemsByUuid,
      addonGroupsByUuid,
    })
  );

export const selectResolveMenuSubItem = createSelector(
  [selectMenuLookups],
  (menuLookups) =>
    (entityId: string): SubItemType | undefined =>
      menuLookups.subItemsByUuid[entityId] ??
      menuLookups.addonSubItemsByUuid[entityId]
);
